export default {
  title: 'Cumpără carduri cadou electronice',
  subtitle:
    'Spune-o cu un card cadou de la {{companyName}}. Perfect pentru aniversări, mulțumiri sau pur și simplu – utilizabil flexibil pentru mâncare și băuturi.',
  header: {
    title: 'Card cadou',
    subtitle: 'Oferă bucurie',
  },
  buttons: {
    buy_now: 'Cumpără acum',
  },
};
